import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import StepZilla from 'react-stepzilla'
import { resetForgotUsername, setUserInfo, requestUsername } from '@severed-links/common.redherrings-reducers/forgotUsername'

import '../SiteRegistration/ProgressTracker.scss'
import * as s from '../ForgotPassword/ForgotPassword.scss'

import ForgotUsernameStep1 from './ForgotUsernameStep1'
import ForgotUsernameStep2 from './ForgotUsernameStep2'
import ForgotUsernameConfirmation from './ForgotUsernameConfirmation'
import PublicAccountShell from '../Public/components/PublicAccountShell'

const ForgotUsername = () => {

    const dispatch = useDispatch()
    const fu = useSelector(state => state.forgotUsername)
    
    useEffect(() => { dispatch(resetForgotUsername()) }, [])

    const steps = [
        { name: 'Send Method', component: <ForgotUsernameStep1 /> },
        { name: fu.sendBy || 'Number', component: <ForgotUsernameStep2  /> },
        { name: 'Confirmation', component: <ForgotUsernameConfirmation />}
    ]
    return (
        <PublicAccountShell
            eyebrow='Account recovery'
            title='Let’s find your username.'
            description='Choose where you want us to send the username associated with your account.'
            icon='user'
            footer={<span>Remembered it? <Link to='/login'>Return to login</Link></span>}>
                <div className={s.flowHeading}>
                    <h2>Recover your username</h2>
                    <p>We’ll guide you through a few quick steps.</p>
                </div>
                <div className={s.forgotPasswordContainer}>
                    <div className='step-progress'>
                        <StepZilla
                            steps={steps}
                            startAtStep={0}
                            showSteps
                            showNavigation
                            stepsNavigation
                            prevBtnOnLastStep
                            preventEnterSubmission={false}
                            nextTextOnFinalActionStep={'Send'}
                            // backButtonText={<span><FontAwesomeIcon name='chevron-left' /> Back</span>}
                            backButtonText={'Back'}
                            backButtonCls={`btn btn-prev btn-light btn-lg`}
                            // nextButtonText={<span>Next <FontAwesomeIcon name='chevron-right' /></span>}
                            nextButtonText={'Next'}
                            nextButtonCls={`btn btn-next btn-light btn-lg${(fu.nextDisabled ? ' ' + s.nextDisabled : ``)}`}
                        />
                    </div>
                </div>
        </PublicAccountShell>
    )
}

export default ForgotUsername
